import React, { useState } from 'react';

const Appointment = () => {
  const [selectedDoctor, setSelectedDoctor] = useState('');
  const [selectedSpecialization, setSelectedSpecialization] = useState('');
  const [appointmentDate, setAppointmentDate] = useState('');
  const [appointmentTime, setAppointmentTime] = useState('');
  const [showDoctorInfo, setShowDoctorInfo] = useState(false);
  const [message, setMessage]  = useState("");
  const [showBookBtn, setShowBookBtn]  = useState(true);

  const [fromTime, setfromTime] = useState('');
  const [toTime, settoTime] = useState('');

  const doctors = ['Dr. John Smith', 'Dr. Sarah Patel', 'Dr. Emily Clark', 'Dr. Ahmed Khan'];
  const specializationList = ['Cardiologist', 'Gastroenterologist', 'Dermatology', 'Obstetrics and gynaecology'];

  const scheduledCalls = [
    { doctor: 'Dr. John Smith', date: '2025-06-20', time: '10:00 AM', status: 'Upcoming' },
    { doctor: 'Dr. Emily Clark', date: '2025-06-21', time: '02:00 PM', status: 'Completed' },
  ];

  const pharmacyData = [
    { medicine: 'Paracetamol', quantity: 2, price: '₹50', status: 'Delivered' },
    { medicine: 'Vitamin D', quantity: 1, price: '₹120', status: 'Pending' },
    { medicine: 'Cough Syrup', quantity: 1, price: '₹80', status: 'Delivered' },
  ];

  const handleBook = () => {
    if (selectedSpecialization && selectedDoctor && appointmentDate && appointmentTime) {
      setShowDoctorInfo(true);
    }
  };

  const handleBookNew = () => {
    setShowBookBtn(false);
    setMessage("Your appoinment has been confirmed")
  };

  return (
    <div className="appointment-container" style={{ padding: '20px' }}>

      <h3>Scheduled Calls</h3>
      <table className="full-width-table">
        <thead>
          <tr>
            <th>Doctor</th>
            <th>Date</th>
            <th>Time</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {scheduledCalls.map((call, index) => (
            <tr key={index}>
              <td>{call.doctor}</td>
              <td>{call.date}</td>
              <td>{call.time}</td>
              <td>{call.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ marginTop: '30px' }}>
        <h3>Find a Doctor</h3>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          flexWrap: 'nowrap',
          overflowX: 'auto'
        }}>
          <div className="inline-input">
            <label htmlFor="doctor">Doctor</label>
            <select
              id="doctor"
              value={selectedSpecialization}
              onChange={(e) => setSelectedSpecialization(e.target.value)}
            >
              <option value="">Select Specialization</option>
              {specializationList.map((doc, i) => (
                <option key={i} value={doc}>{doc}</option>
              ))}
            </select>
          </div>
          <div className="inline-input">
            <label htmlFor="doctor">Doctor</label>
            <select
              id="doctor"
              value={selectedDoctor}
              onChange={(e) => setSelectedDoctor(e.target.value)}
            >
              <option value="">Select Doctor</option>
              {doctors.map((doc, i) => (
                <option key={i} value={doc}>{doc}</option>
              ))}
            </select>
          </div>

          <div className="inline-input">
            <label htmlFor="appt-date">Date</label>
            <input
              id="appt-date"
              type="date"
              value={appointmentDate}
              onChange={(e) => setAppointmentDate(e.target.value)}
            />
          </div>

          <div className="inline-input">
            <label htmlFor="appt-time">Time</label>
            <input
              id="appt-time"
              type="time"
              value={appointmentTime}
              onChange={(e) => setAppointmentTime(e.target.value)}
            />
          </div>

          <div className="inline-input" style={{ marginTop: '22px' }}>
            <button onClick={handleBook}>Find a doctor</button>
          </div>
        </div>

        {showDoctorInfo && (
          <>
          <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f1f9ff', border: '1px solid #cce5ff' }}>
            <h4>Appointment Summary</h4>
            <p><strong>Specialization:</strong> {selectedSpecialization}</p>
            <p><strong>Doctor:</strong> {selectedDoctor}</p>
            <p><strong>Date:</strong> {appointmentDate}</p>
            <p><strong>Time:</strong> {appointmentTime}</p>
              {showBookBtn &&
                <div className="inline-input" style={{ marginTop: '22px' }}>
                  <button onClick={handleBookNew}>Book</button>
                </div>
              }
              {message && <b>{message}</b>}
          </div>
          </>
        )}
      </div>

    </div>
  );
};

export default Appointment;
